import { create } from 'zustand';
import { UserDto } from '@api/generated/bff';

type UserState = {
  beUser: UserDto;
  setBEUser: (user: UserDto) => void;
};

// Zustand store - zachováváme původní API pro .getState() a .setState()
export const useUser = create<UserState>(set => ({
  beUser: {} as UserDto,
  setBEUser(user: UserDto) {
    console.log('Setting BE user:', user);
    set({ beUser: user });
  },
}));
